<template>
  <div id="app">
    <SiteNav></SiteNav>
    <div class="banner">
      <img alt="Vue logo" src="./assets/logo_heyue.png" />
    </div>
    <HelloWorld msg="" />
    <router-view></router-view>
    <SiteBottom></SiteBottom>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import SiteNav from "./components/SiteNav.vue";
import SiteBottom from "./components/SiteBottom.vue";
export default {
  name: "App",
  components: {
    HelloWorld,
    SiteBottom,
    SiteNav
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.banner {
  background-color: rgb(143 225 255 / 89%);
}
a{text-decoration: none;}
.pagetitle{
  font-size:24px;
}
ul{
  list-style: none;
  padding:0;
}
</style>
